import { RoomStructureContent } from '../../../../../definitions/schemas';

/**
 * Determining which value must be used for rendering a text box content
 * based on these possible scenarios in order of priority:
 *  1. Using the latest value from the structure, which is where the most
 *     updated version of the text is contained when the user perform changes:
 *     edit room, preview room or room templates (where the text boxes aren't
 *     contents are all, so they're rendered from the structure)
 *  2. Using the actual piece of content that matches the text box item, for
 *     the contact view, as for this scenario it should already exist
 */
export const getTextBoxDisplayText = (
  structureTextBox: RoomStructureContent
): RoomStructureContent => {
  const { match: structureContent, text = '' } = structureTextBox;

  let content = structureContent;

  if (text) {
    content = {
      ...content,
      text: { html: true, text, version: content.text?.version || 1 },
    };
  }

  return { ...structureTextBox, match: content };
};
